import { registerModule } from '../../core/module.js';
import { Exchange } from './Exchange.js';

/** Exchanges and returns, against a receipt or a gift receipt. */
export default registerModule({
  id: 'exchange',
  order: 20,
  nav: [
    { to: '/exchange', labelKey: 'nav.exchange', icon: '🔁', group: 'sell', permission: 'exchange.do', bottom: 2, order: 2, primary: 3, hintKey: 'nav.hintExchange' },
  ],
  routes: [
    { path: '/exchange', element: <Exchange />, permission: 'exchange.do', titleKey: 'exchange.title' },
  ],
});
